/**
 * The request of the price curve inside the detail of a cell of "Season vs last year" (CU-869fmhmx8 E9). The curve
 * itself (lines, median, marks, tooltip) is shared: `Dashboards/@services/curve.js` (CU-869fmjzrg F0).
 *
 * Pure and alias-free: `node --test` runs it.
 */
import { PERIOD_COMP } from '../../../@services/explorerLink.js'
import { carsBody } from '../../../@services/cars.js'

export const CURVE_REPORT_TYPE = 'season-vs-last-year-curve'

/**
 * The body of `POST /results` for the curve of a column: the view's office, rental length, currency, comparison and
 * cars, and the pick-ups of the column. The server derives the captures and decides the number of days. Neither the
 * statistic nor Tiers / Providers are in it: they never ask again.
 */
export function curveRequestBody({ view, column, currency }) {
	return {
		reportType: CURVE_REPORT_TYPE,
		officePickupID: view.office,
		lor: view.lor,
		currency: currency ?? null,
		isPreviousComparison: true,
		periodComp: { ...PERIOD_COMP[view.cmp] },
		sameWeekday: view.cmp === 'ly' && !view.same,
		isNewVersion: true,
		curvePickupDates: [...(column?.dates || [])],
		...carsBody(view),
	}
}
